export const compareEditedRowObjects = (edited, original, field) => {
  const diff = {};
  const fieldValue = edited[field];
  const referenceObj = Object.values(original).find((obj) => obj[field] === fieldValue);
  if (!referenceObj || typeof referenceObj !== 'object' || referenceObj === null) return diff;
  for (const [key, value] of Object.entries(edited)) {
    if (key !== field) {
      if (key in referenceObj && referenceObj[key] !== value) {
        diff[key] = value !== undefined ? value : null;
      }
    }
  }
  return diff;
};

export const compareAddedRowObjects = (addedRow) => {
  const data = addedRow.map((obj) => {
    return Object.entries(obj)
      .filter(([, value]) => value !== null)
      .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {});
  });
  return data;
};

export function removeNullUndefined(obj) {
  for (const key in obj) {
    if (obj[key] === null || obj[key] === undefined) {
      delete obj[key];
    }
  }
  return obj;
}
